import React, { useState } from 'react';
import { Upload, Library, FileText } from 'lucide-react';
import SimpleFileUploader from './SimpleFileUploader';
import FileLibrarySelector from './FileLibrarySelector';

const UnifiedFilePicker = ({ onFileSelect, allowMultiple = false }) => {
    const [activeTab, setActiveTab] = useState('upload'); // 'upload' | 'library'

    const handleFileSelect = (files) => {
        // Standardize the output format
        // files can be File[] (from upload) or database file objects (from library)
        onFileSelect(files, activeTab);
    };

    return (
        <div className="bg-white rounded-xl">
            {/* Tabs */}
            <div className="flex items-center p-1 bg-gray-100/80 rounded-xl mb-6">
                <button
                    onClick={() => setActiveTab('upload')}
                    className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === 'upload'
                            ? 'bg-white text-gray-900 shadow-sm'
                            : 'text-gray-500 hover:text-gray-700 hover:bg-black/5'
                        }`}
                >
                    <Upload size={16} />
                    Upload New
                </button>
                <button
                    onClick={() => setActiveTab('library')}
                    className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === 'library'
                            ? 'bg-white text-gray-900 shadow-sm'
                            : 'text-gray-500 hover:text-gray-700 hover:bg-black/5'
                        }`}
                >
                    <Library size={16} />
                    Select from Documents
                </button>
            </div>

            {/* Content */}
            <div className="min-h-[300px]">
                {activeTab === 'upload' ? (
                    <div className="animate-in fade-in slide-in-from-left-2 duration-200">
                        <SimpleFileUploader
                            onFileSelect={handleFileSelect}
                            allowMultiple={allowMultiple}
                        />
                        <p className="text-xs text-gray-400 mt-4 text-center">
                            Files uploaded here will be treated as task attachments.
                        </p>
                    </div>
                ) : (
                    <div className="animate-in fade-in slide-in-from-right-2 duration-200 h-full">
                        <FileLibrarySelector
                            onFileSelect={handleFileSelect}
                            allowMultiple={allowMultiple}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default UnifiedFilePicker;
